export const GET_COMPANIES_LOADING = "GET_COMPANIES_LOADING";
export const GET_COMPANIES_SUCCESS = "GET_COMPANIES_SUCCESS";
export const GET_COMPANIES_FAILED = "GET_COMPANIES_FAILED";

export const GET_COMPANIES_DETAILS_LOADING = "GET_COMPANIES_DETAILS_LOADING";
export const GET_COMPANIES_DETAILS_SUCCESS = "GET_COMPANIES_DETAILS_SUCCESS";
export const GET_COMPANIES_DETAILS_FAILED = "GET_COMPANIES_DETAILS_FAILED";


export const BRAND_PORPMTS_LOADING = "BRAND_PORPMTS_LOADING";
export const BRAND_PORPMTS_SUCCESS = "BRAND_PORPMTS_SUCCESS";
export const BRAND_PORPMTS_FAILED = "BRAND_PORPMTS_FAILED";

export const GET_BRAND_PORPMTS_LOADING = "GET_BRAND_PORPMTS_LOADING";
export const GET_BRAND_PORPMTS_SUCCESS = "GET_BRAND_PORPMTS_SUCCESS";
export const GET_BRAND_PORPMTS_FAILED = "GET_BRAND_PORPMTS_FAILED";


